import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {HraComponent} from "./hra.component";
import {MatCardModule} from "@angular/material/card";
import {MatButtonModule} from "@angular/material/button";
import {MatExpansionModule} from "@angular/material/expansion";
import {MatListModule} from "@angular/material/list";
import {MatSelectModule} from "@angular/material/select";
import {MatInputModule} from "@angular/material/input";
import {FormsModule} from "@angular/forms";
import { SecurityImagesComponent } from './security-images/security-images.component';
import {MatDialogModule} from "@angular/material/dialog";
import {MatRadioModule} from "@angular/material/radio";
import {MatButtonToggleModule} from "@angular/material/button-toggle";
import {MatCheckboxModule} from "@angular/material/checkbox";
import { NoopAnimationsModule } from "@angular/platform-browser/animations";

@NgModule({
    declarations: [HraComponent, SecurityImagesComponent],
    imports: [
        CommonModule,
        NoopAnimationsModule,
        MatCardModule,
        MatButtonModule,
        MatExpansionModule,
        MatListModule,
        MatSelectModule,
        MatInputModule,
        FormsModule,
        MatDialogModule,
        MatRadioModule,
        MatButtonToggleModule,
        MatCheckboxModule,
    ],
    exports: [HraComponent]
})
// @ts-ignore
export class HraModule { }
